import * as React from "react";
import { forwardRef, memo } from "react";
const SvgId = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 3 2", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h3v2H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "red", d: "M0 0h3v1H0z" }));
const ForwardRef = forwardRef(SvgId);
const Memo = memo(ForwardRef);
export default Memo;
